import useStore from "../../../Zustand/Zustand";
import { useState, useEffect } from "react";
import { Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import {
  CalendarDaysIcon, InformationCircleIcon,
} from "@heroicons/react/24/outline";
import { PatternFormat, NumericFormat } from "react-number-format"; // Importe os componentes
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ZustandValidationConjugue from "../../../Zustand/ZustandValidationConjugue";

const Link = ({ id, children, title }) => (
  <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
    <a href="#/">{children}</a>
  </OverlayTrigger>
);
const FormConjuge = (props) => {
  const {
    nomeConjugue,
    rendaConjugue,
    nascimentoConjugue,
    setRendaConjugue,
    setNomeConjugue,
    setSecondErro,
    setNascimentoConjugue,

    nomeConjugueIsErro,
    nascimentoConjugueIsErro,
    rendaConjugueIsErro,

    setnomeConjugueIsErro,
    setNascimentoConjugueIsErro,
    setRendaConjugueIsErro,
  } = ZustandValidationConjugue();


  useEffect(() => {
    if (nomeConjugue.length > 1) {
      setnomeConjugueIsErro(false);
    }
  }, [nomeConjugue]);

  useEffect(() => {
    if (rendaConjugue >= 1000) {
      setRendaConjugueIsErro(false);
    }
  }, [rendaConjugue]);

  useEffect(() => {
    if (nascimentoConjugue.length > 1) {
      setNascimentoConjugueIsErro(false);
    }
  }, [nascimentoConjugue]);

  const validateForm = () => {
    let count = 0;
    if (nomeConjugue.length >= 10) {
      count++;
    } else {
      count--;
    }
    if (calcularIdadeTrueOrFalse(nascimentoConjugue)) {
      count++;
    } else {
      count--;
    }
    if (rendaConjugue >= 1000.0) {
      count++;
    } else {
      count--;
    }

    setSecondErro(count != 3);
  };

  function calcularIdadeTrueOrFalse(dataNascimento) {
    if (dataNascimento.length !== 8 || isNaN(dataNascimento)) {
      return false;
    }

    const dia = parseInt(dataNascimento.substring(0, 2), 10);
    const mes = parseInt(dataNascimento.substring(2, 4), 10);
    const ano = parseInt(dataNascimento.substring(4, 8), 10);

    const nascimento = new Date(ano, mes - 1, dia);
    const hoje = new Date();

    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mesAtual = hoje.getMonth() + 1;
    const diaAtual = hoje.getDate();

    if (mesAtual < mes || (mesAtual === mes && diaAtual < dia)) {
      idade--;
    }

    return idade >= 18 && idade <= 100;
  }
  useEffect(() => {
    validateForm();
  }, [nomeConjugue, rendaConjugue, nascimentoConjugue]);

  return (
    <section>
      <Container className="p-0">
        <Col>
          <h1 className="title-proponente ps-1">{props.name1}</h1>
          <Row className="ps-1">
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Form.Label className="label">
                Nome Completo
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={nomeConjugue}
                    onChange={(event) => {
                      const valor = event.target.value;
                      const valorFiltrado = valor.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
                      setNomeConjugue(valorFiltrado);
                    }}
                  />
                </InputGroup>
                {((nomeConjugue.length <= 10 && nomeConjugue !== "") ||
                  nomeConjugueIsErro) && (
                    <p
                      className="text-danger m-0 p-0 mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      Digite o seu nome completo
                    </p>
                  )}
              </Form.Label>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Label className="label">
                Renda Mensal
                <InputGroup>
                  <NumericFormat
                    className="form-control"
                    placeholder="R$ 0,00"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale
                    allowNegative={false}
                    prefix="R$ "
                    value={rendaConjugue}
                    onValueChange={(values) => setRendaConjugue(values.value)}
                    customInput={Form.Control}
                  />
                </InputGroup>
                {((rendaConjugue < 1000 && rendaConjugue != 0) ||
                  rendaConjugueIsErro) && (
                    <p
                      className="text-danger m-0 p-0 mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      Renda inválida
                    </p>
                  )}
              </Form.Label>
            </Col>

            <Col xs={12} sm={4} md={6} lg={4}>
              <Form.Label className="label">
                <div className="d-flex align-items-center justify-content-start gap-1">
                  Nascimento
                  <Link
                    id="t-2"
                    title="A idade deve estar entre 18 e 80 anos."
                  >
                    <InformationCircleIcon
                      strokeWidth={2}
                      style={{
                        width: "15px",
                        paddingBottom: "2px",
                        border: "10px",
                        color: "#555af8",
                      }}
                    />
                  </Link>
                </div>

                <InputGroup>
                  <InputGroup.Text className="bg-white">
                    <CalendarDaysIcon
                      style={{
                        height: "24px",
                        width: "24px",
                        color: "rgba(0, 0, 0, 0.5)",
                      }}
                    />
                  </InputGroup.Text>

                  <PatternFormat
                    format="##/##/####"
                    placeholder="dd/mm/aaaa"
                    value={nascimentoConjugue}
                    onValueChange={(event) =>
                      setNascimentoConjugue(event.value)
                    }
                    customInput={Form.Control}
                  />
                </InputGroup>
                {((nascimentoConjugue.length <= 10 &&
                  !calcularIdadeTrueOrFalse(nascimentoConjugue) &&
                  nascimentoConjugue != "") ||
                  nascimentoConjugueIsErro) && (
                    <p
                      className="text-danger m-0 p-0 mt-1 ms-1"
                      style={{ fontSize: "12px" }}
                    >
                      Data inválida
                    </p>
                  )}
              </Form.Label>
            </Col>
          </Row>
        </Col>
      </Container>
    </section>
  );
};

export default FormConjuge;
